module.exports = __webpack_public_path__ + "assets/img/kiek-kainuoja-saules-elektrine.231dd9c6.webp";